import Vue from "vue";
import Router from "vue-router";
import store from "@/store/index";
import index from "@/views/index";
import login from "@/views/login";
import {
  Message,
} from 'element-ui'; //项目已经全局引入element的话可以不单独引入
Vue.use(Router);
// 获取原型对象上的push函数
const originalPush = Router.prototype.push;
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
const router = new Router({
  routes: [{
    path: "/",
    redirect: "/login"
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登录"
    },
    component: login
  },

  {
    path: "/index",
    name: "index",
    meta: { title: "首页" },
    component: index,
    children: [{
      path: "/home",
      name: "home",
      meta: {
        title: "系统首页"
      },
      component: () => import("../views/home/home.vue")
    }, {
      path: "/xjjg",
      name: "xjjg",
      meta: {
        title: "下级机构"
      },
      component: () => import("../views/org/jggl.vue")
    },
    {
      path: "/jgyg",
      name: "jgyg",
      meta: {
        title: "机构员工"
      },
      component: () => import("../views/orgUser/jgyg.vue")
    }, {
      path: "/ygqx",
      name: "ygqx",
      meta: {
        title: "员工权限"
      },
      component: () => import("../views/orgUser/ygqx.vue")
    },
    {
      path: "/shxx",
      name: "shxx",
      meta: {
        title: "商户信息"
      },
      component: () => import("../views/mch/shxx.vue")
    },
    {
      path: "/sddd",
      name: "sddd",
      meta: {
        title: "商店订单"
      },
      component: () => import("../views/shop/sddd.vue")
    },
    // {
    //   path: "/xjmd",
    //   name: "xjmd",
    //   meta: {
    //     title: "下级门店"
    //   },
    //   component: () => import("../views/mall/mdxx.vue")
    // },
    {
      path: "/mdxx",
      name: "mdxx",
      meta: {
        title: "门店信息"
      },
      component: () => import("../views/mall/mdxx.vue")
    },
    {
      path: "/jhmk",
      name: "jhmk",
      meta: {
        title: "激活码库"
      },
      component: () => import("../views/cpmk/jhmk.vue")
    },
    {
      path: "/xjmk",
      name: "xjmk",
      meta: {
        title: "下级码库"
      },
      component: () => import("../views/cpmk/xjmk.vue")
    },{
      path: "/wmtg",
      name: "wmtg",
      meta: {
        title: "外卖团购"
      },
      component: () => import("../views/cpmk/wmtg.vue")
    },{
      path: "/sfmk",
      name: "sfmk",
      meta: {
        title: "三方码库"
      },
      component: () => import("../views/cpmk/sfmk.vue")
    },
    {
      path: "/imglist",
      name: "imglist",
      meta: {
        title: "图片列表"
      }, // 新增
      component: () => import("../views/imglist/imglist.vue")

    }, {
      path: "/prolist",
      name: "prolist",
      meta: {
        title: "商品列表"
      }, // 新增
      component: () => import("../views/prolist/prolist.vue")

    }, {
      path: "/hbmx",
      name: "hbmx",
      meta: {
        title: "划拨明细"
      }, // 新增
      component: () => import("../views/cpmk/hbmx.vue")

    }, {
      path: "/hbhz",
      name: "hbhz",
      meta: {
        title: "划拨汇总"
      }, // 新增
      component: () => import("../views/cpmk/hbhz.vue")

    }, {
      path: "/wjck",
      name: "wjck",
      meta: {
        title: "文件仓库"
      },
      component: () => import("../views/wjlist/wjlist.vue")

    },
    ]
  }
  ]
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 登录页直接放行
  if (to.path === '/login') {
    next();
    return;
  }

  const token = store.state.smCloudToken;
  if (token) {
    next();
    return;
  }

  Message({
    message: '登录失效，请先登录',
  });
  next('/login');
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js